import useClickOutside from 'Components/GMS/CustomHooks/useClickOutside';
import { AppContext } from 'Context/AppContext';
import { ReportIcon } from 'assests/GmsIcons';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

type TReportMenuProps = {
    onSummaryReportClick: () => void;
    onARSReportClick: () => void;
    isARSAvailable: boolean;
}

export const ReportMenu= ({onSummaryReportClick, onARSReportClick, isARSAvailable}: TReportMenuProps) => {
    const { showMenu, ref, handleClick } = useClickOutside();
    const appContext = useContext(AppContext);

    function containsARS(): boolean {
        if (appContext?.applications?.has(appContext?.selectedParty?.name ?? "")) {
            const values = appContext?.applications?.get(appContext?.selectedParty?.name ?? '');
            return !!values && values.includes("Commend (ARS)");
        } else {
            return false;
        }
    }

    const onSummaryClick = () => {
        handleClick(); 
        onSummaryReportClick();
    }

    const onARSClick = () => {
        // if (!isARSAvailable) {
        //     toast.warn('Please select Commend (ARS) application');
        //     return;
        // }
        handleClick();
        onARSReportClick();
    }
    

    return (
        <div ref={ref} className='tw-relative tw-bg-white tw-z-50'>        
            <div onClick={handleClick} className={`${showMenu ? 'tw-bg-[#EBECF0]' : ''} hover:tw-bg-[#EBECF0] tw-p-2 tw-ms-3 tw-rounded-[4px] tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-[6px]`}>
                <ReportIcon/>
                <button className={`tw-text-sm tw-font-normal tw-text-[#172B4D]`}>Generate Report</button>
            </div>
                {showMenu ? (
                    <div className={`tw-origin-top-left tw-right-0 tw-absolute tw-w-56 tw-mx-3 tw-rounded-[4px] tw-z-50 tw-bg-white tw-ring-1 tw-ring-[#EBECF0]`}>
                        <div className={`tw-py-1`} role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                            <Link onClick={onSummaryClick}  to="#" className={`tw-block tw-px-4 tw-py-1 tw-text-sm tw-text-black hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA]`} role="menuitem">Download Summary Report</Link>
                            <Link onClick={containsARS() ? () => {onARSClick();} : undefined} to="#" className={`tw-block tw-px-4 tw-py-1 tw-text-sm ${containsARS() ? 'tw-text-[#091E42] hover:tw-bg-[#F0F3FE] hover:tw-text-[#091CAA]' : ' tw-text-gray-400 hover:tw-text-gray-400'} `} role="menuitem">Download Commend (ARS) Report</Link>
                        </div>
                    </div>                        
            ) : null}
        </div> 
    )
}
